export default __webpack_public_path__ + "static/media/SVGattendence.6317a6f0.svg";